import { draftRawText, parseDraftRaw } from '../draft/draftRaw';

/**
 * Valeur manquante d'une box variable texte, image ou tableau : ce qui allume
 * le « ! » du formulaire. Règle commune à l'éditeur classique
 * (`hasVariableBoxError`) et au site (onglet Formulaire).
 */

export const isAnUrl = (str) => {
  const matchPattern = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/;
  return matchPattern.test(str);
};

// Une image restée sur son jeton `#{…}` n'a pas de valeur.
export const isImageValueMissing = (src) => !isAnUrl(src);

// Un texte vide n'est une valeur manquante que si le modèle l'exige.
export const isTextBoxValueMissing = (plainText, valueRequired) => !!valueRequired && plainText.length === 0;

export const isCellValueMissing = (value) => {
  if (!value) return true;
  if (typeof value !== 'string') return false;
  if (value.trim() === '') return true;
  // Une cellule Draft sans texte est vide ; tout autre texte est une saisie.
  const raw = parseDraftRaw(value);
  return !!raw && draftRawText(raw).trim() === '';
};

export const isTableValueMissing = (cells) => cells.some(isCellValueMissing);

const TECHNICAL_ROW_KEYS = ['key', 'hiddenColumnsKeys', 'manual'];

// Cellules d'une ligne du classique (`content.data`) : la ligne porte aussi
// son identifiant, ses alignements et ses colonnes masquées.
export const classicTableCells = (data) => (Array.isArray(data) ? data : [])
  .flatMap((row) => Object.entries(row)
    .filter(([key]) => !TECHNICAL_ROW_KEYS.includes(key) && !key.startsWith('textAlign_'))
    .map(([, value]) => value));
